import React, { useEffect, useMemo } from 'react';
import { Checkbox, Drawer, Form } from 'tdesign-react';
import { produce } from 'immer';

const { FormItem } = Form;

export default function Filter({ visible, handleClose, properties, changeProperties }) {
  const [form] = Form.useForm();

  const displays = useMemo(() => {
    const temp = [];

    for (const item of properties) {
      if (item.isDisplay) {
        temp.push(item.key);
      }
    }
    return temp;
  }, [properties]);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        displays,
      });
    }
  }, [form, displays, visible]);

  return (
    <Drawer
      visible={visible}
      closeBtn
      zIndex={7000}
      closeOnEscKeydown
      closeOnOverlayClick
      header='筛选指标'
      mode='overlay'
      onClose={handleClose}
      placement='right'
      preventScrollThrough
      showOverlay
      onConfirm={() => {
        const displayKeys = form.getFieldValue('displays');
        changeProperties(
          produce(properties, (draft) => {
            draft.map((item) => {
              item.isDisplay = false;
              if (displayKeys.find((key) => item.key === key)) {
                item.isDisplay = true;
              }
              return item;
            });
          }),
        );

        handleClose();
      }}
    >
      <Form form={form}>
        <FormItem name='displays'>
          <Checkbox.Group style={{ flexDirection: 'column' }}>
            {properties.map((item) => (
              <Checkbox key={item.key} value={item.key}>
                {item.name}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </FormItem>
      </Form>
    </Drawer>
  );
}
